// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Countdown_countdown__ZxcgT","selector":"Countdown_selector__YCNsU","expiredCountdown":"Countdown_expiredCountdown__2Xw7T","text":"Countdown_text__r8hJ8"};